import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/** Tela que pode ter documento ainda não enviado ao servidor. */
export interface RegisterDealLeaveGuarded {
  confirmLeave(): boolean | Observable<boolean>;
}

/**
 * Pergunta antes de sair do Registrar deal com documento ainda subindo ou em espera (card 3670), na
 * navegação interna. Sair no meio do envio cancela o POST do arquivo, e ele não chega ao deal. Fechar ou
 * recarregar a aba fica com o `beforeunload` do componente. Mesmo desenho do
 * `partnerContractUnsavedChangesGuard`.
 */
export const registerDealLeaveGuard: CanDeactivateFn<RegisterDealLeaveGuarded> = component =>
  component?.confirmLeave ? component.confirmLeave() : true;
